/* Country discovery only: Liquid renders product prices. Dynamic strap UI shares the same fixed rate. */
(() => {
  const node = document.getElementById('vt-liquid-config');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const usd = config.country === 'US' && config.rate > 0;
  const formatter = new Intl.NumberFormat(usd ? 'en-US' : 'en-GB', {style:'currency',currency:usd?'USD':'GBP'});
  function cents(value, linear = false) {
    if (!usd) return Number(value) || 0;
    const converted = Math.round(value * config.rate);
    return linear || value <= 0 ? converted : Math.floor(converted / 100) * 100 + 90;
  }
  function format(value) {return (usd ? 'US' : '') + formatter.format(value / 100);}
  window.VittaroCurrency = {
    formatProduct(value) {return format(cents(value));},
    formatLinear(value) {return format(cents(value,true));},
    formatParts(parts, quantity = 1) {return format(parts.reduce((sum,part)=>sum+cents(part),0)*quantity);}
  };
  function get(key) {try{return localStorage.getItem(key);}catch{return null;}}
  function set(key,value) {try{localStorage.setItem(key,value);}catch{}}
  document.getElementById('vt-liquid-country-form')?.addEventListener('submit',event=>{
    set('vt-liquid-country-choice',event.target.elements.country_code.value);
  });
  // The native selector remains usable without JavaScript.
  if (config.designMode || !(config.rate > 0)) return;
  async function switchCountry(country) {
    if (!['US','GB'].includes(country) || country === config.country) return;
    try {
      const key='vt-liquid-attempt:'+country;
      try {if(sessionStorage.getItem(key))return;sessionStorage.setItem(key,'1');}catch{return;}
      const body=new URLSearchParams({form_type:'localization',_method:'put',country_code:country,return_to:location.pathname+location.search});
      const response=await fetch('/localization',{method:'POST',body,signal:AbortSignal.timeout(5000)});
      if(response.ok)location.reload();
    }catch{}
  }
  const saved=get('vt-liquid-country-choice');
  if (saved==='GB'||saved==='US') {switchCountry(saved);return;}
  let checked=false;
  try {checked=sessionStorage.getItem('vt-liquid-geo-checked')==='1';}catch{}
  if (checked) return;
  const root=config.root.endsWith('/')?config.root:config.root+'/';
  fetch(root+'browsing_context_suggestions.json?country[enabled]=true',{signal:AbortSignal.timeout(5000)})
    .then(response=>response.ok?response.json():Promise.reject())
    .then(data=>{
      const country=data.detected_values?.country?.handle;
      if (!country) return;
      try{sessionStorage.setItem('vt-liquid-geo-checked','1');}catch{}
      return switchCountry(country==='US'?'US':'GB');
    }).catch(()=>{});
})();
